module.exports = __webpack_public_path__ + "static/media/image_fail_icon.f9c9543a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/image_fail_icon.svg
// module id = 260
// module chunks = 0